<aca-page-layout [hasError]="!isValidPath">
  <aca-page-layout-header>
    <adf-toolbar class="adf-toolbar--inline">
      <!-- <adf-breadcrumb [root]="fileName"></adf-breadcrumb> -->

      <div class="adf-viewer__file-title">

        <span class="adf-viewer__display-name"
              id="adf-viewer-display-name">{{ fileName }}</span>
      </div>
    </adf-toolbar>

    <button
                            class="adf-viewer-close-button"
                            data-automation-id="adf-toolbar-left-back"
                            [attr.aria-label]="'ADF_VIEWER.ACTIONS.CLOSE' | translate"
                            mat-icon-button
                            title="{{ 'ADF_VIEWER.ACTIONS.CLOSE' | translate }}"
                            (click)="onClose()">
                        <mat-icon>close</mat-icon>
                    </button>

  </aca-page-layout-header>

  <aca-page-layout-error>
   <!-- <aca-generic-error></aca-generic-error> -->
  </aca-page-layout-error>

  <aca-page-layout-content>
    <div class="main-content">

    <span *ngIf="srcUrl$ | async | safe as url">
      <iframe [src]="url"></iframe>

      <style>
        iframe {
          flex: 1;
          width: 99vw;
          height: 95vh;
        }
      </style>
    </span>
{{nodeId}}
    </div>

  </aca-page-layout-content>
</aca-page-layout>
